<template>
  <div v-html="content"></div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      content: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    const url =
      this.$route.query.type === "news"
        ? this.$api.REFERENCE_NEWS_DETAIL
        : this.$api.REFERENCE_HEALTHY_DETAIL;
    this.$http
      .post(url, {
        id: this.id
      })
      .then(res => {
        this.content = res.content;
      });
  }
};
</script>

<style lang="less" scoped>
.list-item {
  display: flex;
  align-items: center;
  margin: 0.9rem;
  padding: 1rem;
  border-bottom: 1px solid #f4f4f4;
}
</style>

<style lang="less">
.van-dialog__message {
  overflow-x: hidden;
}
</style>
